import type { Effect, Input } from "@banuba/webar"

export type State = {
  effect: Effect | null
  source: Input | null
}

const createState = (): State => {
  return {
    effect: null,
    source: null,
  }
}

export const Analysis = createState()
